// extracted by mini-css-extract-plugin
export default {"dropdownList":"category_dropdownList__FqBt4","title":"category_title__O2st4"};